import { useContext } from 'react';
import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { formatMoney } from 'services/utils';
import './CommissionAccountsTableRow.scss';
import Button from '../../../../../../uikit/Button/Button';

const CommissionAccountsTableRow = ({ isLoading, commissionAccountData, handleOpenUpdateIbanModal }) => {
  const i18n = useContext(i18nContext);

  const getCommissionAccountInfoBlock = (accountBlockInfo, isUpdateCommissionAccountIban = false) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'commission-accounts-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (isUpdateCommissionAccountIban) {
      return (
        <Button
          onClick={() => handleOpenUpdateIbanModal(commissionAccountData?.account_number, commissionAccountData?.iban)}
          type={'primary'}
          size={'small'}
        >
          {i18n.getMessage('commissions.commissionAccounts.button.updateIban')}
        </Button>
      );
    } else {
      return <p>{accountBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'commission-accounts-table-cell'}>
        {getCommissionAccountInfoBlock(commissionAccountData.account_number)}
      </td>
      <td className={'commission-accounts-table-cell'}>
        {getCommissionAccountInfoBlock(i18n.getMessage(`paymentProvider.${commissionAccountData.transfer_provider}`))}
      </td>
      <td className={'commission-accounts-table-cell'}>{getCommissionAccountInfoBlock(commissionAccountData.iban)}</td>
      <td className={'commission-accounts-table-cell'}>
        {getCommissionAccountInfoBlock(formatMoney(commissionAccountData.amount))}
      </td>
      <td className={'commission-accounts-table-cell'}>
        {getCommissionAccountInfoBlock(commissionAccountData.currency)}
      </td>
      <td className={'commission-accounts-table-cell'}>{getCommissionAccountInfoBlock(commissionAccountData, true)}</td>
    </tr>
  );
};

CommissionAccountsTableRow.propTypes = {
  isLoading: PropTypes.bool,
  commissionAccountData: PropTypes.shape({
    account_number: PropTypes.string,
    amount: PropTypes.number,
    iban: PropTypes.string,
    currency: PropTypes.string,
    transfer_provider: PropTypes.string,
    type: PropTypes.string
  }),
  handleOpenUpdateIbanModal: PropTypes.func
};

export default CommissionAccountsTableRow;
